import { BookmarkSimple } from "@phosphor-icons/react";
import { TAG_COLORS } from "../constants/tagColors";
import recipePlaceholderBg from "../assets/recipe-placeholder-bg.svg";

function RecipeGridCard({
  recipe,
  isMobile,
  appTheme,
  hoveredButton,
  setHoveredButton,
  openRecipeDetails,
  openRecipeQuickAdd,
  toggleFavourite,
  favouriteRecipes,
  hideCustomBadge
}) {
  const isFav = favouriteRecipes.includes(recipe.name);

  const firstTag = recipe.tags?.[0];
  const tagColor = firstTag ? (TAG_COLORS[firstTag] || null) : null;
  const tagLabel = firstTag ? firstTag.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : null;

  return (
    <div
      onClick={() => openRecipeDetails(recipe, true)}
      style={{
        borderRadius: "18px",
        overflow: "hidden",
        cursor: "pointer",
        position: "relative",
        height: isMobile ? "225px" : "250px",
        background: recipe.image
          ? `url(${recipe.image}) center/cover no-repeat`
          : `url(${recipePlaceholderBg}) center/cover no-repeat`,
      }}
    >
      {/* Gradient overlay */}
      <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to top, rgba(0,0,0,0.72) 0%, transparent 60%)" }} />

      {/* Bookmark — top right */}
      <div style={{ position: "absolute", top: "6px", right: "6px" }}>
        <button
          onClick={(e) => { e.stopPropagation(); toggleFavourite(recipe.name); }}
          style={{
            width: "32px", height: "32px", borderRadius: "999px",
            background: "rgba(0,0,0,0.35)", border: "none",
            backdropFilter: "blur(8px)", WebkitBackdropFilter: "blur(8px)",
            cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
          }}
          aria-label={isFav ? "Remove from favourites" : "Add to favourites"}
        >
          <BookmarkSimple weight={isFav ? "fill" : "bold"} color="#ffffff" size={16} />
        </button>
      </div>

      {/* Custom badge — top left (library-only) */}
      {recipe.custom && !hideCustomBadge && (
        <div style={{
          position: "absolute", top: "6px", left: "6px",
          padding: "3px 8px", borderRadius: "999px",
          border: "1px solid rgba(255,255,255,0.32)",
          background: "rgba(255,255,255,0.18)",
          color: "#ffffff", fontSize: "10px", fontWeight: "700",
          backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)",
        }}>
          Custom
        </div>
      )}

      {/* Bottom content — name + pills */}
      <div style={{ position: "absolute", bottom: "10px", left: "12px", right: "12px" }}>
        <div style={{ color: "#ffffff", fontSize: isMobile ? "14px" : "15px", fontWeight: "500", fontFamily: appTheme.fontBody, lineHeight: 1.2, marginBottom: "7px", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
          {recipe.name}
        </div>
        {(() => {
          const darkPill = { background: "rgba(0,0,0,0.52)", backdropFilter: "blur(4px)", WebkitBackdropFilter: "blur(4px)", color: "#fff", fontSize: "10px", fontWeight: "700", padding: "3px 8px", borderRadius: "999px", letterSpacing: "0.06em", whiteSpace: "nowrap" };
          const darkPillSm = { ...darkPill, fontSize: "9px", padding: "3px 7px" };
          const tagPillStyle = { background: tagColor, color: "#ffffff", fontSize: "9px", fontWeight: "700", padding: "3px 7px", borderRadius: "999px", letterSpacing: "0.06em", whiteSpace: "nowrap", display: "inline-block" };

          if (recipe.custom) {
            // Priority hierarchy for custom recipes
            const hasTime     = recipe.time != null && recipe.time !== "" && recipe.time !== 0;
            const hasCalories = recipe.calories != null && recipe.calories !== "";
            const hasProtein  = recipe.macros?.protein != null && recipe.macros?.protein !== "";

            const pill1 = hasTime
              ? <span style={darkPill}>{recipe.time} MIN</span>
              : hasCalories
              ? <span style={darkPill}>{recipe.calories} kcal</span>
              : null;

            const pill2 = (tagLabel && tagColor)
              ? <span style={tagPillStyle}>{tagLabel}</span>
              : hasProtein
              ? <span style={darkPillSm}>{Math.round(recipe.macros.protein)}g protein</span>
              : null;

            return (pill1 || pill2) ? (
              <div style={{ display: "flex", gap: "5px", flexWrap: "wrap", alignItems: "center" }}>
                {pill1}
                {pill2}
              </div>
            ) : null;
          }

          // Standard logic for saved public recipes
          return (
            <div style={{ display: "flex", gap: "5px", flexWrap: "wrap", alignItems: "center" }}>
              {recipe.time != null && <span style={darkPill}>{recipe.time} MIN</span>}
              {tagLabel && tagColor && <span style={tagPillStyle}>{tagLabel}</span>}
            </div>
          );
        })()}
      </div>
    </div>
  );
}

export default RecipeGridCard;
